import { SelectOption } from "@msys/ui";
import { UserAvatarFragment } from "./UserAvatar.generated.js";

export const getPersonLabel = (
  person: { firstname: string; familyname: string },
  compact: boolean
) =>
  compact
    ? `${
        person.firstname && person.firstname.length > 0
          ? `${person.firstname[0]}.`
          : ""
      } ${person.familyname}`.trim()
    : `${person.firstname} ${person.familyname}`.trim();

export const getMemberOptions = (
  members: Array<{ id: string; firstname: string; familyname: string }>,
  compact: boolean = false
): SelectOption[] => {
  return members
    .map(m => ({
      label: getPersonLabel(m, compact),
      value: m.id,
    }))
    .sort(alphabeticSortByLabel);
};

export function memberToMemberOption<
  Member extends {
    id: string;
    firstname: string;
    familyname: string;
    avatar: { id: string; url: string };
  },
>(member: Member) {
  return {
    ...member,
    label: getPersonLabel(member, false),
    value: member.id,
    userAvatar: {
      __typename: "User" as const,
      ...member,
      avatar: { __typename: "AttachmentSnapshot" as const, ...member.avatar },
    },
  };
}

export function alphabeticSortByLabel(
  a: { label: string },
  b: { label: string }
) {
  return a.label.toLocaleLowerCase().localeCompare(b.label.toLocaleLowerCase());
}
